import React, { useState, useEffect } from 'react';
import { Menu, Tooltip } from 'antd';
import { NavLink } from 'react-router-dom';
import { xor } from 'lodash';
import CustomScrollbars from 'components/CustomScrollbars';
import { StyledMenu, StyledSubMenu, StyledGroup, StyledIcon, StyledTitle, StyledCollapsedTitle } from './Navigation.styled';

const Navigation = ({ location, menuData, menuCollapsed, menuMobile }) => {
    const arrayLocation = location.pathname.replace(/^(\/)(.*)(?!(\/))$/g, '$2').split('/');
    const getOpenKeys = arrayLocation.length > 1 && !menuCollapsed ? [arrayLocation[0]] : [];

    const [openKeys, setOpenKeys] = useState(getOpenKeys);

    useEffect(() => {
        setOpenKeys(() => (menuCollapsed ? [] : getOpenKeys));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menuCollapsed]);

    function handleOpen(keys) {
        setOpenKeys(state => (menuCollapsed ? [] : xor(state, keys)));
    }

    function handleOpenEnter(domEvent, key) {
        if (menuCollapsed) {
            setOpenKeys([key]);
        }

        domEvent.persist();
    }

    return (
        <CustomScrollbars className="gx-layout-sider-scrollbar">
            <StyledMenu
                theme="lite"
                mode="inline"
                selectedKeys={[arrayLocation[1]]}
                openKeys={openKeys}
                onOpenChange={handleOpen}
            >
                {
                    menuData.map(menu => (
                        menu !== ''
                            ? (
                                <StyledSubMenu
                                    key={menu.key}
                                    onMouseEnter={({ domEvent }) => handleOpenEnter(domEvent, menu.key)}
                                    title={!menu.subs && menuCollapsed ? (
                                        <Tooltip placement="right" title={menu.title} overlayStyle={{ transform: 'translateX(13px)' }}>
                                            {
                                                menu.path !== '' ? (
                                                    <NavLink to={menu.path} style={{ marginRight: menuCollapsed ? '23px' : 0 }}>
                                                        <StyledIcon className={`la la-${menu.icon}`} />
                                                        <StyledTitle>{menu.title}</StyledTitle>
                                                    </NavLink>
                                                ) : (
                                                    <span style={{ marginRight: menuCollapsed ? '23px' : 0 }}>
                                                        <StyledIcon className={`la la-${menu.icon}`} />
                                                        <StyledTitle>{menu.title}</StyledTitle>
                                                    </span>
                                                )
                                            }
                                        </Tooltip>
                                    ) : (
                                        <React.Fragment>
                                            { menu.path !== '' ? (
                                                <NavLink to={menu.path}>
                                                    <StyledIcon className={`la la-${menu.icon}`} />
                                                    <StyledTitle>{menu.title}</StyledTitle>
                                                </NavLink>
                                            ) : (
                                                <span>
                                                    <StyledIcon className={`la la-${menu.icon}`} />
                                                    <StyledTitle>{menu.title}</StyledTitle>
                                                </span>
                                            ) }
                                        </React.Fragment>
                                    )}
                                    hasarrow={menu.subs}
                                >
                                    {
                                        menu.subs && (
                                            <Menu.ItemGroup title={menuCollapsed && !menuMobile ? <StyledCollapsedTitle>{menu.title}</StyledCollapsedTitle> : null}>
                                                {menu.subs.map(submenu => (
                                                    (submenu !== ''
                                                        ? (
                                                            <StyledGroup key={submenu.path.replace(/^(\/)(.*)(?!(\/))$/g, '$2').split('/')[1]}>
                                                                <NavLink to={`${submenu.path}/`}>{submenu.title}</NavLink>
                                                            </StyledGroup>
                                                        )
                                                        : '')
                                                ))}
                                            </Menu.ItemGroup>
                                        )
                                    }
                                </StyledSubMenu>
                            )
                            : ''
                    ))
                }
            </StyledMenu>
        </CustomScrollbars>
    );
};

export default Navigation;
